import { render, staticRenderFns } from "./listturtles1.vue?vue&type=template&id=2d24330c&scoped=true&"
import script from "./listturtles1.vue?vue&type=script&lang=js&"
export * from "./listturtles1.vue?vue&type=script&lang=js&"
import style0 from "./listturtles1.vue?vue&type=style&index=0&id=2d24330c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24330c",
  null
  
)

export default component.exports